var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4533 23.2L26.0933 7.55997C27.1635 6.5628 27.604 5.06101 27.2421 3.64377C26.8801 2.22652 25.7735 1.11986 24.3562 0.757918C22.939 0.395979 21.4372 0.836491 20.44 1.90664L4.76001 17.5866C4.65972 17.6897 4.57444 17.8064 4.50667 17.9333L0.800008 25.4133C0.597312 25.827 0.622518 26.316 0.866672 26.7066C1.11083 27.0973 1.53934 27.3342 2.00001 27.3333C2.22 27.3281 2.43529 27.2686 2.62667 27.16L10.1067 23.4533C10.2335 23.3855 10.3502 23.3003 10.4533 23.2ZM26 27.3333C26.7364 27.3333 27.3333 26.7364 27.3333 26C27.3333 25.2636 26.7364 24.6666 26 24.6666H14C13.2636 24.6666 12.6667 25.2636 12.6667 26C12.6667 26.7364 13.2636 27.3333 14 27.3333H26ZM19.76 10.12L17.88 8.23997L6.84001 19.3333L4.98667 23.0666L8.66667 21.16L19.76 10.12ZM23.2867 3.33164C23.6522 3.33164 24.0016 3.48167 24.2533 3.74664C24.5132 4.00381 24.656 4.35639 24.6485 4.7219C24.6409 5.08741 24.4836 5.43377 24.2133 5.67997L21.64 8.23997L19.76 6.35997L22.32 3.74664C22.5717 3.48167 22.9212 3.33164 23.2867 3.33164Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bf373e98e9cb998aefb8c4643af4471e.svg";
export { ForwardRef as ReactComponent };